import { Grid, Paper } from "@material-ui/core";
import { ModalDeleteConfirm, Title } from "App/Component/ui";
import { WMS_PBF_PEMBAYARAN } from "App/constants";
import {
  defaultToastSuccess,
  isNull,
  defaultToastError,
  formatNumber,
  convertToValidPrice,
} from "App/utils/helpers";

import React, { useState } from "react";
import { useEffect } from "react";
import FormInputPembayaran from "./FormInputPembayaran";
import {
  deletePembayaranPembelianByID,
  getPembayaranByPembelianID,
  RESET_STATE_PEMBAYARAN,
} from "./helpers";
import TableListPembayaran from "./TableListPembayaran";

function Pembayaran({ data, menu }) {
  const [pembayaranID, setPembayaranID] = useState(null);
  const [total, setTotal] = useState(() => {
    if (!isNull(data) && menu === WMS_PBF_PEMBAYARAN) {
      return {
        totalPembelian: data.total_pembelian,
        totalPembayaran: 0,
      };
    } else {
      return {
        totalPembelian: 0,
        totalPembayaran: 0,
      };
    }
  });

  const [formData, setFormData] = useState(() => {
    if (isNull(data)) {
      return RESET_STATE_PEMBAYARAN;
    } else {
      if (menu === WMS_PBF_PEMBAYARAN) {
        return data;
      } else {
        return RESET_STATE_PEMBAYARAN;
      }
    }
  });

  useEffect(() => {
    if (isNull(data)) {
      return setFormData(RESET_STATE_PEMBAYARAN);
    } else {
      if (menu === WMS_PBF_PEMBAYARAN) {
        setTotal({
          totalPembelian: data.total_pembelian,
          totalPembayaran: convertToValidPrice(data.jumlah_bayar2),
        });
        return setFormData(data);
      } else {
        return setFormData(RESET_STATE_PEMBAYARAN);
      }
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const [rowsPembayaranByPembelianID, setRowsPembayaranByPembelianID] =
    useState([]);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const setNewDataPembayaranByPembelian = async (
    id = formData.pembelian_id
  ) => {
    if (!isNull(formData.pembelian_id)) {
      const response = await getPembayaranByPembelianID(id);
      if (response.state) {
        setRowsPembayaranByPembelianID(response.data);
      } else {
        setRowsPembayaranByPembelianID([]);
      }
    } else {
      setRowsPembayaranByPembelianID([]);
    }
  };

  useEffect(() => {
    (async () => {
      await setNewDataPembayaranByPembelian();
    })();
  }, [formData.pembelian_id]); // eslint-disable-line react-hooks/exhaustive-deps

  async function deleteList() {
    const res = await deletePembayaranPembelianByID(pembayaranID);

    if (res.state) {
      defaultToastSuccess(res.message);
      await setNewDataPembayaranByPembelian();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  const clickDelete = (id) => {
    setPembayaranID(id);
    setShowModalDeleteConfirm(true);
  };

  useEffect(() => {
    let temp = 0;
    rowsPembayaranByPembelianID.map((item) => (temp += item.jumlah_bayar));
    setTotal({
      ...total,
      totalPembayaran: temp,
    });
  }, [rowsPembayaranByPembelianID.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <Title title='Pembayaran Pembelian' />
      <Paper
        style={{
          padding: "1rem",
        }}>
        <Grid container spacing={2}>
          <Grid item sm={12}>
            <FormInputPembayaran
              setNewDataPembayaranByPembelian={setNewDataPembayaranByPembelian}
              setTotal={setTotal}
              formData={formData}
              setFormData={setFormData}
              total={total}
            />
          </Grid>
          <Grid item sm={12}>
            <table
              width={"100%"}
              style={{
                marginBottom: "1rem",
              }}>
              <tr>
                <td width={"20%"}>Total Pembelian</td>
                <td witdh='2%'>:</td>
                <td width={"70%"}>{formatNumber(total.totalPembelian)}</td>
              </tr>
              <tr>
                <td width={"20%"}>Total Pembayaran</td>
                <td witdh='2%'>:</td>
                <td>{formatNumber(total.totalPembayaran)}</td>
              </tr>
            </table>
            <TableListPembayaran
              rows={rowsPembayaranByPembelianID}
              clickDelete={clickDelete}
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}

export default Pembayaran;
